import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  warningMessage: {
    id: '/si96j',
    description: 'Warning message for unmatched columns',
    defaultMessage: '{amount, plural, one {# CSV field} other {# CSV fields}} could not be matched and will not be imported: ',
  },
  showMoreColumns: {
    id: '52G6p/',
    description: 'Message at the end of the list of unmatched columns',
    defaultMessage: '...and more',
  },
  hideMoreColumns: {
    id: 'Zj+nN4',
    description: 'Message to hide the list of unmatched columns',
    defaultMessage: 'hide',
  },
});
